import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MAP_CONSTANTS, COUNTRY_MAP_COORDINATES } from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import * as _ from 'underscore';
import * as jQuery from 'jquery';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import * as M from 'mapbox-gl';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { MapComponentService } from '../map/map.component.service';
import { MapComponent } from '../map/map.component';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';

@Component({
	selector: 'app-map-v4',
	templateUrl: './map-v4.component.html',
	styleUrls: ['./map-v4.component.css'],
	providers: [MapComponentService]
})
export class MapV4Component extends MapComponent implements OnInit, AfterViewInit, WidgetCore, OnDestroy {
	@Input() uniqueoverwriteid: string;
	public popup;
	protected mapStyle = 'mapbox://styles/freq-e-deek/cjj0jrlj00mdk2sqj1vah6775';

	public circleMarkerStyles = {
		'circle-color': '#4a4a4a',
		'circle-radius': 5,
		'circle-stroke-color': '#FFF',
		'circle-stroke-width': 1
	};

	/**
	 *
	 * @type {{productName: string; productKey: string; isDisabled: boolean; isSelected: boolean}[]}
	 */
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Television',
			productKey: MAP_CONSTANTS.STATE.TELEVISION_MIDCO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasTelevision'],
			order: 1
		},
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 2
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 3
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 4
		},
		{
			productName: 'Connected TV',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 5
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: true,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 6
		}
	];

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
	}

	ngOnInit() {
		super.ngOnInit();
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 23;
		this.mapCoordinates['lat'] = this.partnerCountryLngLat['lat'] + 1;
		this.defaultMapZoom = 3.5;
	}

	ngAfterViewInit() {
		super.ngAfterViewInit();
	}

	setPolygonDetailsElementPosition(e) {
		const height = jQuery('.map-region-container').height();
		const width = jQuery('.map-region-container').width();
		const mapHeight = jQuery('#map').height();
		let posX = e.originalEvent.offsetX - 250;
		let posY = e.originalEvent.offsetY < 0 ? 0 : e.originalEvent.offsetY;
		if (posX < 0) {
			posX = 20;
			posY = posY - height - 20;
		}
		if (posX > 0 && posY + height > mapHeight + 20) {
			posY = posY - height - 20;
		}
		jQuery('.map-region-container').css('top', posY + 'px');
		jQuery('.map-region-container').css('left', posX + 'px');
		jQuery('.map-region-container').css('display', 'block');
	}

	setGeofenceDetailsElemPosition(gfMarker) {
		const mapWidth = jQuery('#map').width();
		const mapHeight = jQuery('#map').height();
		const height = jQuery('.map-details-container').height();
		const width = jQuery('.map-details-container').width();
		const x = gfMarker._pos.x;
		const y = gfMarker._pos.y;
		let top = y - (height / 2 + 44);
		top = top < 0 ? 0 : top;
		top = top + height > mapHeight + 20 ? top - (top + height - mapHeight) - 20 : top;
		let left = x + 20;
		if (left + width > mapWidth) {
			left = x - width - 20;
		}
		jQuery('.map-details-container').css('top', top);
		jQuery('.map-details-container').css('left', left);
		jQuery('.map-details-container').css('display', 'block');
	}

	/**
	 *
	 * @param {string} mapSourceLayer
	 * @param {string} vectorMapId
	 * @param filter
	 * @param propertyToFilter
	 * @param opacity
	 */
	protected drawRegionsLayer(
		mapSourceLayer: string,
		vectorMapId: string,
		filter: any,
		propertyToFilter: any,
		opacity?: any
	) {
		if (mapSourceLayer === 'polygons') {
			this.removeMapLayer(this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': opacity
				},
				filter: filter[filter.length - 1]
			});

			this.removeMapLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer,
				type: 'fill',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: {
					'fill-color': this.mapFillColor,
					'fill-outline-color': this.mapFillOutlineColor,
					'fill-opacity': 1
				},
				filter: ['==', propertyToFilter, '']
			});

			let geo_hover_timeout;
			this.map.on('mousemove', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject, e);
					this.setPolygonDetailsElementPosition(e);
				}
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							e.features[0].properties[propertyToFilter]
						]);
					}
				}, 10);
			});

			this.map.on('mouseleave', this.mapType + '_main_' + vectorMapId + '_' + mapSourceLayer, () => {
				jQuery('.map-region-container').css('display', 'none');
				this.hideLocationDataOnMouseout();
				clearTimeout(geo_hover_timeout);
				geo_hover_timeout = setTimeout(() => {
					if (this.map.getLayer(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer)) {
						this.map.setFilter(this.mapType + '_hover_' + vectorMapId + '_' + mapSourceLayer, [
							'==',
							propertyToFilter,
							''
						]);
					}
				}, 10);
			});
		} else if (mapSourceLayer === 'points') {
			this.removeMapLayer(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: this.circleMarkerStyles,
				filter: filter[filter.length - 1]
			});
			this.map.setLayerZoomRange(this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.removeMapLayer(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer);
			this.map.addLayer({
				id: this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer,
				type: 'circle',
				source: this.mapType + '_geography_source_' + vectorMapId,
				'source-layer': mapSourceLayer,
				paint: this.circleMarkerStyles,
				filter: ['==', propertyToFilter, '']
			});
			this.map.setLayerZoomRange(this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, 1, 15);

			this.map.on('mousemove', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject, e);
				}
			});
			this.map.on('mousemove', this.mapType + '_inactive_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				if (propertyToFilter === 'gcd_id') {
					const regionObject = _.findWhere(this.selectedCombination.regionData, {
						gcd_id: e.features[0].properties['gcd_id'].toString()
					});
					this.displayLocationDataOnMouseover(regionObject, e);
					const posX = e.originalEvent.offsetX - 250;
					jQuery('.map-region-container').css('top', e.originalEvent.offsetY + 'px');
					jQuery('.map-region-container').css('left', posX + 'px');
					jQuery('.map-region-container').css('display', 'block');
				}
			});
			this.map.on('mouseleave', this.mapType + '_active_' + vectorMapId + '_' + mapSourceLayer, (e) => {
				jQuery('.map-region-container').css('display', 'none');
				this.hideLocationDataOnMouseout();
			});
		}
	}

	/**
	 *
	 */
	protected drawGeoFencePoints() {
		this.removeAllGeoFenceMarkers();
		this.geoFenceMarkers = [];
		this.displayGeoFenceData.features.forEach((marker) => {
			// create a DOM element for the marker
			const el = document.createElement('div');
			el.className = 'marker';
			el.style.backgroundImage = 'url(' + this.markericon + ')';
			el.style.backgroundPosition = 'center';
			el.style.backgroundSize = 'cover';
			el.style.width = 32 + 'px';
			el.style.height = 40 + 'px';
			// add marker to map
			const gfMarker: any = new M.Marker(el)
				.setLngLat([marker.properties.center_point_longitude, marker.properties.center_point_latitude])
				.addTo(this.map);
			this.geoFenceMarkers.push(gfMarker);
			el.addEventListener('mouseover', (event) => {
				this.showGeofenceCenterDetails(marker.properties);
				this.setGeofenceDetailsElemPosition(gfMarker);
			});

			el.addEventListener('mouseleave', (event) => {
				this.hideGeofenceCenterDetails();
			});
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
}
